<script lang="ts" setup>
import LnxLogo from '@/components/icons/logo/LnxLogo.vue'
import SignetGroup from '@/components/icons/signet/SignetGroup.vue'
import { useConnectStore } from '@/libs/api/connect/connect.store.ts'
import { translate } from '@/i18n/i18n.ts'

const connectStore = useConnectStore()
</script>

<template>
  <div class="siteconnect-header">
    <LnxLogo class="siteconnect-header__logo" />
    <h4 class="siteconnect-header__headline siteconnect-header--order-headline">
      {{ translate('content.title_bike') }}
    </h4>
    <SignetGroup
      :signets="connectStore.getSignets"
      class="siteconnect-header--order-signets siteconnect-header__signets"
    />
  </div>
</template>

<style lang="scss" scoped>
@import 'siteconnect-header';
</style>
